import { MultiLineTextInput, MultiLineTextInputProps } from "dash-styled"
import React, { ChangeEvent, FC } from "react"

type DelimitedTextInputProps = Omit<MultiLineTextInputProps, "inputProps"> & {
    value: string[] | undefined
    placeholder?: string
    onChange: (value: string[] | undefined) => void
}

export const DelimitedTextInput: FC<DelimitedTextInputProps> = ({
    value,
    placeholder,
    onChange,
    ...props
}) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const v = e.target.value
        const isDeleting =
            v.slice(-1) === "," && value?.[value.length - 1] === ""

        onChange(
            v === ""
                ? undefined
                : isDeleting
                ? value?.slice(0, -1)
                : v.split(/[,\s\n]+/).map(vv => vv.trim())
        )
    }

    return (
        <MultiLineTextInput
            {...props}
            disableCursorPositionFix={
                true /* disable cursor position fix because it interferes with text modification */
            }
            inputProps={{
                value: value?.join(", ") ?? "",
                placeholder,
                onChange: handleChange
            }}
        />
    )
}
